<template>
    <div class="posts__container" v-cloak>
        <TopFilter :taxonomy="setFilterTaxonomy()" @tax-updated="topFilterUpdated"></TopFilter>
        <div id="posts__scrollto-container"></div>
        <div :class="{ 'posts__loader--loading' : posts.loading }" class="posts__loader">
            <img v-bind:src="loaderSvgUrl"/>
        </div>
        <div :class="{ 'posts__outer--loading' : posts.loading }" class="posts__outer">
            <div v-for="(item, index) in posts.items" :key="item.id" class="tile tile--in-grid">
                <a :href="item.link" class="tile__inner" v-if="checkTileType(index, 'post', item)">
                    <span class="tile__image-container">
                        <img class="tile__image" v-if="item.fimg_url" :src="item.fimg_url" width="418" height="260"/>
                    </span>
                    <span class="tile__content">
                        <div v-if="item.tax_inspiratie" class="tile__label">
                             <span v-for="tax in item.tax_inspiratie">{{ tax }}</span>
                        </div>
                        <span class="tile__title" v-if="item.title" v-html="item.title.rendered"></span>
                        <span class="tile__text" v-if="setItemExcerpt(item.acf)" v-html="item.acf.tile_intro"></span>
                        <span class="tile__text" v-if="setItemExcerpt(item.acf) === false" v-html="item.excerpt"></span>
                    </span>
                </a>
                <div class="tile__inner tile__inner--is-cta" v-if="checkTileType(index, 'cta')">
                    <img class="tile__bg-image" v-if="item.imageUrl" :src="item.imageUrl" width="417" height="540"/>
                    <div class="tile__cta-text" v-if="item.text" v-html="item.text"></div>
                    <a v-if="item.buttonUrl" :href="item.buttonUrl" target="_blank" rel="noopener"
                       class="tile__cta-button button button--large button--orange-d">{{ item.buttonText }}</a>
                </div>
            </div>
        </div>
        <div class="posts__pagination-container">
            <pagination v-model="posts.pagination.page" :records="posts.headers.totalItems" :per-page="12" @paginate="paginate()" :options="posts.pagination.options" />
        </div>
    </div>
</template>

<script>

import axios from 'axios';
import Pagination from 'vue-pagination-2';
import TopFilter from './TopFilter';
import setLanguage from './mixins/setLanguage';
import MyPagination from './Pagination';
import setCanonicals from "./mixins/setCanonicals";

export default {
    data() {
        return {
            posts: {
                headers: {
                    totalItems: 1,
                    totalPages: Number,
                },
                items: [],
                loading: true,
                perPage: 12,
                pagination: {
                    page: 1,
                    options: {
                        theme: 'bootstrap4',
                        chunk: 10,
                        chunksNavigation: 'fixed',
                        template: MyPagination
                    }
                }
            },
            ctaTile: {
                dataFilled: false,
                enabled: false,
                imageUrl: String,
                text: String,
                buttonUrl: String,
                buttonText: String
            },
            filterValues: [],
            filterState: false,
            filterTaxonomy: String,
            postType: 'posts',
            baseUrl: '',
            language: '',
            errors: [],
            initialPageLoad: true,
            loaderSvgUrl: null
        }
    },
    mixins: [setLanguage, setCanonicals],
    components: {
        Pagination,
        TopFilter
    },
    mounted() {
        // We need to start here because we need to know if a CTA tile must be shown on the fifth position. After we know that we start loading posts via loadPosts()
        // this.tileCTA();
        this.setBaseUrl();
        this.setPaginationFromParam();
        this.getLoaderSvg();
        this.language = this.setLanguage();
        this.postType = this.setPostType();
        this.filterTaxonomy = this.setFilterTaxonomy();
    },
    methods: {

        // Get ACF data CTA tile from WordPress
        tileCTA() {
            let _this = this;

            // Get page id from data-attribute from container element
            let postEl = document.getElementById('posts');
            let postId = null;
            if (postEl) {
                postId = postEl.getAttribute('data-id');
            } else {
                console.warn('tileCTA() is fired but element with matching id does not exist.');
            }

            if (postId && this.ctaTile.dataFilled == false) {

                // Add language to url based window.location
                let urlLang = '';
                if (window.location.pathname.replace(/^\/([^\/]*).*$/, '$1').length == 2) {
                    urlLang = '/' + window.location.pathname.replace(/^\/([^\/]*).*$/, '$1');
                }

                let fetchUrl = window.location.origin + '/wp-json/wp/v2/pages?include[]=' + postId;

                if (urlLang) {
                    fetchUrl = window.location.origin + urlLang + '/wp-json/wp/v2/pages?include[]=' + postId;
                }

                return axios.get(fetchUrl)
                    .then(response => {
                        let acfContent = response.data[0].acf;

                        if (acfContent) {
                            _this.ctaTile.imageUrl = (acfContent.cta_tile_bg_image) ? acfContent.cta_tile_bg_image.sizes.large : null;
                            _this.ctaTile.text = (acfContent.cta_tile_text) ? acfContent.cta_tile_text : null;
                            _this.ctaTile.buttonText = (acfContent.cta_button_text) ? acfContent.cta_button_text : null;
                            _this.ctaTile.buttonUrl = (acfContent.cta_button_url) ? acfContent.cta_button_url : null;

                            // Enable tile if necessary content exists
                            if (acfContent.cta_tile_bg_image && acfContent.cta_tile_text) {
                                _this.ctaTile.enabled = true;
                            }
                        } else {
                            console.warn('tileCTA(): ACF content is not set');
                        }
                        _this.ctaTile.dataFilled = true;
                        _this.loadPosts();
                    })
                    .catch(e => {
                        _this.errors.push(e);
                    });
            } else {
                // Enable tile if necessary content exists
                if (this.ctaTile.imageUrl && this.ctaTile.text) {
                    _this.ctaTile.enabled = true;
                }
                _this.loadPosts();
            }
        },

        loadPosts() {
            let _this = this;

            // Fetch posts
            let pagePosts = function pagePosts() {
                let fetchUrl = _this.fetchUrl();

                return axios.get(fetchUrl)
                    .then(response => {
                        // Set 'headers' meta data
                        _this.posts.headers.totalItems = parseInt(response.headers['x-wp-total']);
                        _this.posts.headers.totalPages = parseInt(response.headers['x-wp-totalpages']);

                        // Set posts to local data
                        _this.posts.items = response.data;

                        if (_this.initialPageLoad === true) {
                            _this.setCanonicals(_this.posts.pagination.page, _this.posts.headers.totalPages);
                        }

                        _this.initialPageLoad = false;
                    })
                    .catch(e => {
                        _this.errors.push(e);
                    });
            }

            let axiosQueue = [pagePosts()];
            if (axiosQueue) {
                return Promise.all(axiosQueue)
                    .then(function (v) {
                        // Disable loading
                        _this.posts.loading = false;

                        // Insert CTA tile at fifth position if exists and on first page and no filter is set
                        if (_this.ctaTile.enabled && _this.posts.pagination.page == 1 && _this.filterState == false) {
                            let ctaTileObj = _this.ctaTile;
                            _this.posts.items.splice(4, 0, ctaTileObj);
                        }
                    })
                    .catch(function(e) {
                        console.error('Promise all error', e);
                    });
            }
        },

        fetchUrl() {
            let perPage = (this.ctaTile.enabled && this.posts.pagination.page == 1 && this.filterState == false) ? 11 : this.posts.perPage;

            let filterParamsString = '';
            if (this.filterValues.length > 0) {
                for (var i = 0; i < this.filterValues.length; i++) {
                    if (this.filterValues[i].id != -1) {
                        let paramName = this.filterValues[i].name;
                        let paramValue = this.filterValues[i].id;
                        filterParamsString += '&' + paramName + '=' + paramValue;
                    }
                }
            }

            let pageNumber = '';
            if (!filterParamsString) {
                pageNumber = '&page=' + this.posts.pagination.page;
            }

            let postType = this.postType;

            let fetchUrl = window.location.origin + '/wp-json/wp/v2/' + postType + '?per_page=' + perPage + pageNumber + filterParamsString;
            // if (this.language != 'en') {
            //     fetchUrl = window.location.origin + '/' + this.language + '/wp-json/wp/v2/' + postType + '?per_page=' + perPage + pageNumber + filterParamsString;
            // }

            return fetchUrl;
        },

        setPaginationFromParam() {
            let _this = this;
            if (_this.initialPageLoad === true) {
                let queryString = decodeURIComponent(window.location.hash.replace('#!/', ''));
                queryString = '?' + queryString.substring(1);
                let urlParams = new URLSearchParams(queryString);
                if (urlParams.get('page') !== null) {
                    let pageParam = parseInt(urlParams.get('page'));
                    if (pageParam) {
                        _this.posts.pagination.page = pageParam;
                    }
                }
            }
        },

        setPostType() {
            let postEl = document.getElementById('posts');
            let postType = null;
            if (postEl) {
                postType = postEl.getAttribute('data-posttype');
            }
            if (postType) {
                return postType;
            }
        },

        setFilterTaxonomy() {
            let postEl = document.getElementById('posts');
            let postCat = null;
            if (postEl) {
                postCat = postEl.getAttribute('data-tax');
            }
            if (postCat) {
                return postCat;
            }
        },

        setItemExcerpt(itemAcf) {
            if (itemAcf) {
                return !!itemAcf.tile_intro;
            }
        },

        checkTileType(index, type, item) {
            if (this.ctaTile.enabled == true && this.posts.pagination.page == 1) {
                if ((type == 'post' && index != 4 && item.title !== 'undefined') || (type == 'post' && index == 4 && this.filterState == true)) {
                    return true;
                }
                if (type == 'cta' && index == 4 && this.filterState == false) {
                    return true;
                }
            } else {
                if (type == 'post' && item.title !== 'undefined') {
                    return true;
                } else {
                    return false;
                }
            }

            return false;
        },

        paginate() {
            this.posts.loading = true;
            this.loadPosts();
            this.generateUrlParameters();
            setTimeout(function() {
                document.getElementById('posts__scrollto-container').scrollIntoView({
                    behavior: 'smooth'
                });
            }, 300);
        },

        topFilterUpdated: function (value) {

            // Reset pagination
            if (this.initialPageLoad == false) {
                this.posts.pagination.page = 1;
            }

            if (value !== undefined) {
                // Set filterState (if any filters are set)
                this.filterState = (value.id != -1) ? true : false;

                // Fill filterValues
                if (this.filterValues.length > 0) {
                    for (var i = 0; i < this.filterValues.length; i++) {
                        if (this.filterValues[i].name == value.name) {
                            this.filterValues[i].id = value.id;
                        }
                    }
                } else {
                    this.filterValues.push(value);
                }
            }
            this.posts.loading = true;
            this.generateUrlParameters();
            this.tileCTA();
        },

        setBaseUrl() {
            this.baseUrl = window.location.origin;
        },

        generateUrlParameters() {
            let _this = this;
            let urlParamaters = [];

            if (this.filterValues.length > 0) {
                for (var i = 0; i < this.filterValues.length; i++) {
                    let value = this.filterValues[i].id;
                    let base = this.filterValues[i].name;

                    let parameter = _this.createParameter(value, base);

                    if (parameter) {
                        urlParamaters.push(parameter);
                    }
                }
            }

            let addressBarParameters = '';
            let p;
            for (p = 0; p < urlParamaters.length; p++) {
                // If is not last item then add ampersand
                let cur = p + 1
                if (cur != urlParamaters.length) {

                    addressBarParameters += urlParamaters[p];
                    addressBarParameters += '&';
                } else {
                    addressBarParameters += '&';
                    addressBarParameters += urlParamaters[p];
                }
            }

            if (_this.posts.pagination.page !== 1) {
                addressBarParameters += '&page=' + _this.posts.pagination.page;
            }

            // Set parameters in address bar
            if (addressBarParameters.length > 0) {
                window.location.hash = '#!/' + addressBarParameters;
            } else {
                window.location.hash = '';
                window.history.replaceState({}, '', window.location.href.slice(0, -1));
            }
        },

        createParameter(value, base) {
            let parameterBase = base;

            if (value != -1) {
                if (typeof value == 'number' || typeof value == 'string') {
                    if (typeof value == 'string') {
                        value = encodeURIComponent(value);
                    }
                    parameterBase += '='
                    parameterBase += value;

                    let parameter = parameterBase;
                    return parameter;
                }
            }
        },

        getLoaderSvg() {
            let loaderPath = '/wp-content/themes/woodpro/src/svg/loader.svg';

            if(window.location.origin.includes('woodpro.dev')) {
                loaderPath = '/app/themes/woodpro/src/svg/loader.svg';
            }

            this.loaderSvgUrl = this.baseUrl + loaderPath;
        },
    }
}

</script>
